<script setup lang="ts">
import { Toast } from 'primevue';
import AppFooter from './components/AppFooter.vue';
import HandicapCheck from './components/auth/HandicapCheck.vue';
import DebugUserSwitcher from './components/DebugUserSwitcher.vue';
import Header from './components/HeaderMenu.vue';

const isDev = import.meta.env.DEV;
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <Toast />
    <Header />
    <main class="flex-1">
      <RouterView />
    </main>
    <AppFooter />
    <HandicapCheck />
    <DebugUserSwitcher v-if="isDev" />
  </div>
</template>
